// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { infoProps } from "@store/Themes/common/props/info";
import * as React from "react";
import { useContext } from "react";

export interface OrderDetailsShipToNumberStyles {
    titleText?: TypographyProps;
    description?: TypographyProps;
    wrapper?: InjectableCss;
}

export const orderDetailsShipToNumberStyles: OrderDetailsShipToNumberStyles = {
    titleText: infoProps.label,
    description: infoProps.value,
};

const styles = orderDetailsShipToNumberStyles;

const OrderDetailsShipToNumber: React.FunctionComponent = () => {
    const { value: order } = useContext(OrderStateContext);
    if (!order) {
        return null;
    }

    const shipToNumber = order.customerSequence ?? "";
    const billToNumber = order.customerNumber ?? "";

    if (!shipToNumber && !billToNumber) {
        return null;
    }

    const displayedShipToNumber = shipToNumber || billToNumber;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate("Ship-To Number")}</Typography>
            <Typography {...styles.description}>{displayedShipToNumber}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShipToNumber,
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        group: "Order Details",
    },
};

export default widgetModule;
